import { BUSINESS_TOOL_SECTIONS } from 'constants/businessTool';

export const prefix = `${BUSINESS_TOOL_SECTIONS.LEGAL_FRAMEWORKS_AND_RISKS}` as const;

export const ACTIONS_FOR_SUPPORT_NAMES = {
  ACTION: 'stage',
  START_DATE: 'startDate',
  EXPECTED_DEADLINE: 'expectedDeadline',
} as const;

export interface IActionsForSupport {
  [ACTIONS_FOR_SUPPORT_NAMES.ACTION]: string;
  [ACTIONS_FOR_SUPPORT_NAMES.START_DATE]: string;
  [ACTIONS_FOR_SUPPORT_NAMES.EXPECTED_DEADLINE]: string;
}

export const actionsForSupportValue = {
  [ACTIONS_FOR_SUPPORT_NAMES.ACTION]: '',
  [ACTIONS_FOR_SUPPORT_NAMES.START_DATE]: '',
  [ACTIONS_FOR_SUPPORT_NAMES.EXPECTED_DEADLINE]: '',
};

export const LIST_OF_RISKS_NAMES = {
  NAME: 'name',
  GROUP: 'group',
  NEGATIVE_IMPACT: 'negativeImpact',
  PREVENTION_MEASURES: 'preventionMeasures',
} as const;

export interface IListOfRisks {
  [LIST_OF_RISKS_NAMES.NAME]: string;
  [LIST_OF_RISKS_NAMES.GROUP]: { label: string; value: string };
  [LIST_OF_RISKS_NAMES.NEGATIVE_IMPACT]: string;
  [LIST_OF_RISKS_NAMES.PREVENTION_MEASURES]: string;
}

export const listOfRisksValue = {
  [LIST_OF_RISKS_NAMES.NAME]: '',
  [LIST_OF_RISKS_NAMES.GROUP]: { label: '', value: '' },
  [LIST_OF_RISKS_NAMES.NEGATIVE_IMPACT]: '',
  [LIST_OF_RISKS_NAMES.PREVENTION_MEASURES]: '',
};

export const LEGAL_FRAMEWORK_AND_RISKS_NAMES = {
  GENERAL_LAWS: 'generalLaws',
  INDUSTRY_REQUIREMENTS: 'industryRequirements',
  LEGAL_REQUIREMENTS: 'legalRequirements',
  LIST_OF_ACTIONS: 'listOfActions',
  LIST_OF_RISKS: 'listOfRisks',
} as const;

export interface ILegalFrameworkAndRisks {
  [LEGAL_FRAMEWORK_AND_RISKS_NAMES.GENERAL_LAWS]: string;
  [LEGAL_FRAMEWORK_AND_RISKS_NAMES.INDUSTRY_REQUIREMENTS]: string;
  [LEGAL_FRAMEWORK_AND_RISKS_NAMES.LEGAL_REQUIREMENTS]: string;
  [LEGAL_FRAMEWORK_AND_RISKS_NAMES.LIST_OF_ACTIONS]: IActionsForSupport[];
  [LEGAL_FRAMEWORK_AND_RISKS_NAMES.LIST_OF_RISKS]: IListOfRisks[];
}

export const legalFrameworkAndRisksInitialValues: ILegalFrameworkAndRisks = {
  [LEGAL_FRAMEWORK_AND_RISKS_NAMES.GENERAL_LAWS]: '',
  [LEGAL_FRAMEWORK_AND_RISKS_NAMES.INDUSTRY_REQUIREMENTS]: '',
  [LEGAL_FRAMEWORK_AND_RISKS_NAMES.LEGAL_REQUIREMENTS]: '',
  [LEGAL_FRAMEWORK_AND_RISKS_NAMES.LIST_OF_ACTIONS]: [actionsForSupportValue],
  [LEGAL_FRAMEWORK_AND_RISKS_NAMES.LIST_OF_RISKS]: [listOfRisksValue],
};
